__turbopack_context__.v({
  "active": "IA4VDa_active",
  "atTop": "IA4VDa_atTop",
  "container": "IA4VDa_container",
  "header": "IA4VDa_header",
  "headerNavDesktop": "IA4VDa_headerNavDesktop",
  "headerNavMobile": "IA4VDa_headerNavMobile",
  "hidden": "IA4VDa_hidden",
  "logo": "IA4VDa_logo",
  "logoContainer": "IA4VDa_logoContainer",
  "mobileActions": "IA4VDa_mobileActions",
  "mobileNavToggle": "IA4VDa_mobileNavToggle",
  "mobileSearchButton": "IA4VDa_mobileSearchButton",
  "nav-toggle-bottom-bar-active": "IA4VDa_nav-toggle-bottom-bar-active",
  "nav-toggle-middle-bar-active": "IA4VDa_nav-toggle-middle-bar-active",
  "nav-toggle-top-bar-active": "IA4VDa_nav-toggle-top-bar-active",
  "wrapper": "IA4VDa_wrapper",
});
